<!-- Connector card list -->
@if (!isWorkspaceConnector) {
  <section class="med_customer-connector">
    @if (isListView) {
      <div #listTypeCard class="med_connector-list position-relative w-100">
        <div class="d-flex justify-content-between align-items-center">
          <div class="med_connector-start-col d-flex justify-content-start align-items-center w-100">
            @if (connector.connector.icon || connector.connection_parameters.favicon) {
              <img
                class="med_connector-img object-fit-content"
                [alt]="connector.name"
                [src]="connector.connector.icon ? connector.connector.icon : connector.connection_parameters.favicon"
              />
            }
            <div class="med_connector-info w-100 me-2">
              <h2
                class="xs-title med_connector-name text-start text-truncate"
                [attr.id]="'list' + connector.uuid"
                [ngbTooltip]="
                  isOverflowText('list' + connector.uuid)
                    ? !connector.parentUuid
                      ? connector.name
                      : connector.name + ' | ' + connector.parent.name
                    : ''
                "
              >
                {{ connector.name }}
                @if (connector.parentUuid) {
                  <span class="l-body med_connector-family">{{ connector.parent.name }}</span>
                }
              </h2>
              <div class="d-flex justify-content-start align-items-center">
                @if (connector.is_logged_in && connector.connected_user) {
                  <p class="s-body med_connector-account mt-1">
                    {{ "account" | translate }}: {{ connector.connected_user }}
                  </p>
                }
                @if (connector.is_logged_in && !connector.connected_user && connector.connector.is_authenticatable) {
                  <p class="s-body med_connector-account mt-1">
                    {{ "no_account_info" | translate }}
                  </p>
                }
                @if (!connector.is_logged_in && connector.subconnectors.length) {
                  <button
                    class="s-body med_connector-collapse d-flex justify-content-start align-items-center mt-1"
                    (click)="toggleCollapse()"
                  >
                    {{ "subconnectors" | translate }}
                    ({{ connector.subconnectors.length }})
                    <app-icon icon="chevron-down" [ngClass]="{ rotated: !isCollapsed }" />
                  </button>
                }
                @if (connector.connector.is_authenticatable && !connector.is_logged_in && showConnectorButton) {
                  <button
                    type="button"
                    class="btn btn-outline-primary med_connect-btn"
                    (click)="goToLogin()"
                    target="_blank"
                  >
                    <app-icon icon="plug" class="icon-light" />
                    {{ "sign_in" | translate }}
                  </button>
                }
              </div>
            </div>
          </div>
          <div class="med_connector-end-col d-flex justify-content-end align-items-center flex-shrink-0">
            @if (connector.is_logged_in) {
              <label class="switch" [class.checked]="connector.is_enabled">
                <input
                  type="checkbox"
                  (change)="connector.is_enabled ? disconnectClick(connector, true) : connectClick(connector, true)"
                  [name]="connector.name"
                  [checked]="connector.is_enabled"
                  [disabled]="
                    (processing && connectorUpdatedUuid === connector.uuid) ||
                    (connector.connector.is_authenticatable && !connector.is_logged_in)
                  "
                  [id]="connector.name + connectorIndex"
                />
                <span class="slider"></span>
              </label>
            }
            <!-- Three dots menu -->
            <mat-icon-button
              class="three-dots-vetical position-relative d-flex justify-content-center align-items-center"
              [matMenuTriggerFor]="menu"
            >
              <app-icon icon="ellipsis-vertical" />
            </mat-icon-button>
            <mat-menu #menu="matMenu">
              <div class="three-dots-menu">
                @if (connector.is_logged_in && connector.connector.is_authenticatable) {
                  <button mat-menu-item (click)="openDisconnectModal(connector)">
                    <app-icon icon="no-plug" class="icon-active" /> {{ "disconnect_from" | translate | titlecase }}
                    {{ connector.name }}
                  </button>
                }
                <button mat-menu-item (click)="openInfoModal(connector)">
                  <app-icon icon="circle-info" class="icon-active" />{{ "about" | translate | titlecase }}
                  {{ connector.name }}
                </button>
              </div>
            </mat-menu>
            <!-- #Three dots menu -->
          </div>
        </div>
        @if (connector.subconnectors.length) {
          <ng-container>
            <div [ngbCollapse]="isCollapsed">
              <div class="med_sub-connectors">
                @for (subConnector of connector.subconnectors; track subConnector; let j = $index) {
                  <div class="med_sub-connector d-flex justify-content-between align-items-center">
                    <div class="med_sub-connector-start-col d-flex justify-content-start align-items-center w-100">
                      @if (subConnector.connector.icon) {
                        <img
                          class="med_sub-connector-img object-fit-contain flex-shrink-0 my-0 mx-1"
                          [src]="subConnector.connector.icon"
                          [alt]="subConnector.name"
                        />
                      }
                      <p
                        class="l-body medium text-truncate mw-100 text-start"
                        [attr.id]="'sub-connector-list' + subConnector.uuid"
                        [ngbTooltip]="isOverflowText('sub-connector-list' + subConnector.uuid) ? subConnector.name : ''"
                      >
                        <span class="l-body">{{ subConnector.name }}</span>
                      </p>
                    </div>
                    <div class="d-flex justify-content-end align-items-center">
                      <!--<div
                      *ngIf="processing && connectorUpdatedUuid === subConnector.uuid"
                      class="spinner-border text-dark"
                      role="status"
                    ></div>-->
                      <!-- <p class="secondary-color">{{ "news_and_media" | translate }}</p> -->
                      @if (subConnector.is_logged_in) {
                        <label class="switch" [class.checked]="subConnector.is_enabled">
                          <input
                            type="checkbox"
                            (change)="
                              connector.is_enabled
                                ? disconnectClick(subConnector, true)
                                : connectClick(subConnector, true)
                            "
                            [name]="subConnector.name"
                            [checked]="subConnector.is_enabled"
                            [disabled]="
                              (processing && connectorUpdatedUuid === subConnector.uuid) ||
                              (subConnector.connector.is_authenticatable && !subConnector.is_logged_in)
                            "
                            [id]="subConnector.name + connectorIndex"
                          />
                          <span class="slider"></span>
                        </label>
                      }
                      <!-- Three dots menu -->
                      <mat-icon-button
                        class="three-dots-vetical-subconnector d-flex justify-content-center align-items-center"
                        [matMenuTriggerFor]="menu"
                      >
                        <app-icon icon="ellipsis-vertical" />
                      </mat-icon-button>
                      <mat-menu #menu="matMenu">
                        <div class="three-dots-menu">
                          <button mat-menu-item (click)="openInfoModal(subConnector)">
                            <app-icon icon="circle-info" class="icon-active" />{{ "about" | translate | titlecase }}
                            {{ subConnector.name }}
                          </button>
                        </div>
                      </mat-menu>
                      <!-- #Three dots menu -->
                    </div>
                  </div>
                }
              </div>
            </div>
          </ng-container>
        }
      </div>
    }
    <!-- #Connector list-->

    <!-- Connector connected -->
    @if ((!connector.connector.is_authenticatable || connector.is_logged_in) && !isListView) {
      <div
        #connectedCard
        class="med_connector-connected position-relative w-100"
        [ngClass]="{ has_sub_connectors: connector.subconnectors.length }"
        data-cy="med_connector_card_connected"
      >
        <!-- Three dots menu -->
        <mat-icon-button
          class="three-dots-vetical position-absolute d-flex justify-content-center align-items-center"
          [matMenuTriggerFor]="menu"
        >
          <app-icon icon="ellipsis-vertical" />
        </mat-icon-button>
        <mat-menu #menu="matMenu">
          <div class="three-dots-menu">
            @if (connector.is_logged_in && !connector.parentUuid && connector.connector.is_authenticatable) {
              <button mat-menu-item (click)="openDisconnectModal(connector)">
                <app-icon icon="no-plug" class="icon-active" /> {{ "disconnect_from" | translate | titlecase }}
                {{ connector.name }}
              </button>
            }
            @if (connector.is_logged_in && connector.parentUuid && connector.connector.is_authenticatable) {
              <button mat-menu-item (click)="openDisconnectModal(connector)">
                <app-icon icon="no-plug" class="icon-active" /> {{ "disconnect_from" | translate | titlecase }}
                {{ connector.parent.name }}
              </button>
            }
            <!--<button *ngIf="connector.is_logged_in && connector.connector.is_authenticatable" mat-menu-item>
          <app-icon icon="arrows-rotate" class="icon-active" />{{ "change_account" | translate }}
        </button>-->
            <button mat-menu-item (click)="openInfoModal(connector)">
              <app-icon icon="circle-info" class="icon-active" />{{ "about" | translate | titlecase }}
              {{ connector.name }}
            </button>
          </div>
        </mat-menu>
        <!-- #Three dots menu -->
        <div class="w-100 d-flex justify-content-between align-items-end position-relative">
          <div class="med_switch-wrapper position-absolute">
            <label class="switch" [class.checked]="connector.is_enabled">
              <input
                type="checkbox"
                (change)="connector.is_enabled ? disconnectClick(connector, true) : connectClick(connector, true)"
                [name]="connector.name"
                [checked]="connector.is_enabled"
                [disabled]="
                  (processing && connectorUpdatedUuid === connector.uuid) ||
                  (connector.connector.is_authenticatable && !connector.is_logged_in)
                "
                [id]="connector.name + connectorIndex"
                data-cy="med_connector_card_connected_switch"
              />
              <span class="slider"></span>
            </label>
          </div>
          <div class="med_connector-info d-flex flex-column w-100 align-self-start">
            @if (connector.connector.icon || connector.connection_parameters.favicon) {
              <img
                class="med_connector-img object-fit-contain"
                [alt]="connector.name"
                [src]="connector.connector.icon ? connector.connector.icon : connector.connection_parameters.favicon"
              />
            }
            <h2
              class="xs-title med_connector-name text-truncate text-start"
              [attr.id]="'connected' + connector.uuid"
              [ngbTooltip]="
                isOverflowText('connected' + connector.uuid)
                  ? !connector.parentUuid
                    ? connector.name
                    : connector.name + ' | ' + connector.parent.name
                  : ''
              "
            >
              {{ connector.name }}
              @if (connector.parentUuid) {
                <span class="l-body med_connector-family">{{ connector.parent.name }}</span>
              }
            </h2>
            @if (connector.is_logged_in && connector.connected_user) {
              <div class="d-flex align-items-center justify-content-between pt-1 gap-1">
                <p class="s-body me-1">{{ "account" | translate }}: {{ connector.connected_user }}</p>
              </div>
            }
            @if (connector.is_logged_in && !connector.connected_user && connector.connector.is_authenticatable) {
              <div class="d-flex align-items-center justify-content-between pt-1 gap-1">
                <p class="s-body me-1">
                  {{ "no_account_info" | translate }}
                </p>
              </div>
            }
          </div>

          <!-- <div class="switch-container">
      <label class="switch" [class.checked]="connector.is_enabled">
        <input type="checkbox"
          (change)="connector.is_enabled ? disconnectClick(connector, true) : connectClick(connector, true)"
              [name]="connector.name" [checked]="connector.is_enabled" [disabled]="
                (processing && connectorUpdatedUuid === connector.uuid) ||
                (connector.connector.is_authenticatable && !connector.is_logged_in)
              " [id]="connector.name + connectorIndex" />
        <span class="slider"></span>
      </label>
    </div> -->
          @if (processing && connectorUpdatedUuid === connector.uuid) {
            <div class="med_spinner-border position-absolute text-dark" role="status"></div>
          }
        </div>
        @if (connector.subconnectors.length && !onboarding) {
          <div class="med_sub-connectors">
            <mat-expansion-panel
              class="med_sub-connector-panel"
              (click)="activeAnimationSubconnectorList()"
              (afterCollapse)="finishAnimationSubconnectorList()"
              (afterExpand)="finishAnimationSubconnectorList()"
              [expanded]="false"
            >
              <mat-expansion-panel-header class="justify-content-start h-auto p-0 m-0">
                <mat-panel-title class="med_sub-connector-title justify-content-center">
                  <p class="s-body">
                    <!-- <span class="secondary-color">Multiple types</span> -->
                    {{ "sub_connectors" | translate }}<span class="s-body">({{ connector.subconnectors.length }})</span>
                  </p>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (subConnector of connector.subconnectors; track subConnector; let j = $index) {
                <div
                  class="med_sub-connector-list-item d-flex justify-content-between align-items-center py-1 px-0"
                  [ngClass]="{
                    disabled:
                      (processing && connectorUpdatedUuid === subConnector.uuid) ||
                      (subConnector.connector.is_authenticatable && !subConnector.is_logged_in),
                  }"
                >
                  <div class="med_sub-connector-start-col d-flex justify-content-start align-items-center w-100">
                    @if (subConnector.connector.icon) {
                      <img
                        class="med_sub-connector-img object-fit-contain flex-shrink-0 my-0 mx-1"
                        [src]="subConnector.connector.icon"
                        [alt]="subConnector.name"
                      />
                    }
                    <p
                      class="xl-body medium text-truncate mw-100 text-start d-flex flex-column"
                      [attr.id]="'dis-connected-subconnector' + subConnector.uuid"
                      [ngbTooltip]="
                        isOverflowText('dis-connected-subconnector' + subConnector.uuid) ? subConnector.name : ''
                      "
                    >
                      <span class="l-body">{{ subConnector.name }}</span>
                      <span class="s-body secondary-color">{{ "news_and_media" | translate }}</span>
                    </p>
                  </div>
                  <div class="d-flex justify-content-end align-items-center">
                    <!--<div
              *ngIf="processing && connectorUpdatedUuid === subConnector.uuid"
              class="med_spinner-border position-absolute text-dark"
              role="status"
            ></div>-->
                    <div class="form-check form-switch pe-auto form_active_toggle">
                      <label [for]="subConnector.name"></label>
                    </div>
                    <div class="switch-container">
                      <label class="switch" [class.checked]="subConnector.is_enabled">
                        <input
                          type="checkbox"
                          (change)="
                            subConnector.is_enabled
                              ? disconnectClick(subConnector, true)
                              : connectClick(subConnector, true)
                          "
                          [name]="subConnector.name"
                          [checked]="subConnector.is_enabled"
                          [disabled]="
                            (processing && connectorUpdatedUuid === subConnector.uuid) ||
                            (subConnector.connector.is_authenticatable && !subConnector.is_logged_in)
                          "
                          [id]="subConnector.name + connectorIndex"
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                    <!-- <p class="s-body secondary-color">{{ "news_and_media" | translate }}</p> -->
                    <!-- Three dots menu -->
                    <mat-icon-button
                      class="three-dots-vetical-subconnector d-flex justify-content-center align-items-center"
                      [matMenuTriggerFor]="menu"
                    >
                      <app-icon icon="ellipsis-vertical" />
                    </mat-icon-button>
                    <mat-menu #menu="matMenu">
                      <div class="three-dots-menu">
                        <button mat-menu-item (click)="openInfoModal(subConnector)">
                          <app-icon icon="circle-info" class="icon-active" />{{ "about" | translate | titlecase }}
                          {{ subConnector.name }}
                        </button>
                      </div>
                    </mat-menu>
                    <!-- #Three dots menu -->
                  </div>
                </div>
              }
            </mat-expansion-panel>
          </div>
        }
      </div>
    }
    <!-- #Connector connected-->

    <!-- Connector login -->
    @if (connector.connector.is_authenticatable && !isListView && !connector.is_logged_in) {
      <div
        #loginCard
        class="med_connector-login d-flex flex-column justify-content-start align-items-end position-relative w-100"
        [ngClass]="{ has_sub_connectors: connector.subconnectors.length }"
      >
        <!-- Three dots menu -->
        <mat-icon-button
          class="three-dots-vetical position-absolute d-flex justify-content-center align-items-center"
          [matMenuTriggerFor]="menu"
        >
          <app-icon icon="ellipsis-vertical" />
        </mat-icon-button>
        <mat-menu #menu="matMenu">
          <div class="three-dots-menu">
            @if (connector.is_logged_in && connector.connector.is_authenticatable) {
              <button mat-menu-item (click)="openDisconnectModal(connector)">
                <app-icon icon="no-plug" class="icon-active" /> {{ "disconnect_from" | translate | titlecase }}
                {{ connector.name }}
              </button>
            }
            <!--<button *ngIf="connector.is_logged_in && connector.connector.is_authenticatable" mat-menu-item>
        <app-icon icon="arrows-rotate" class="icon-active" />{{ "change_account" | translate }}
      </button>-->
            <button mat-menu-item (click)="openInfoModal(connector)">
              <app-icon icon="circle-info" class="icon-active" />{{ "about" | translate | titlecase }}
              {{ connector.name }}
            </button>
          </div>
        </mat-menu>
        <!-- #Three dots menu -->
        <div class="d-flex flex-column justify-content-start w-100">
          @if (connector.connector.icon || connector.connection_parameters.favicon) {
            <img
              class="med_connector-img object-fit-contain"
              [alt]="connector.name"
              [src]="connector.connector.icon ? connector.connector.icon : connector.connection_parameters.favicon"
            />
          }
          <div class="d-flex w-100 justify-content-between align-items-center position-relative">
            <h2
              class="xs-title text-truncate text-start mw-100"
              [attr.id]="'dis-connected' + connector.uuid"
              [ngbTooltip]="isOverflowText('dis-connected' + connector.uuid) ? connector.name : ''"
            >
              {{ connector.name }}
              @if (connector.subconnectors.length) {
                <span></span>
              }
            </h2>
            @if (connector.connector.is_authenticatable && !connector.is_logged_in) {
              <button
                type="button"
                class="btn btn-outline-primary med_connect-btn position-absolute"
                (click)="goToLogin()"
                target="_blank"
              >
                {{ "sign_in" | translate }}
              </button>
            }
          </div>
          @if (!connector.subconnectors.length) {
            <p class="s-body secondary-color">
              <!-- {{ "news_and_media" | translate }} -->
            </p>
          }
          @if (connector.subconnectors.length && !onboarding) {
            <div class="med_sub-connectors">
              <mat-expansion-panel
                class="med_sub-connector-panel"
                (click)="activeAnimationSubconnectorList()"
                (afterCollapse)="finishAnimationSubconnectorList()"
                (afterExpand)="finishAnimationSubconnectorList()"
              >
                <mat-expansion-panel-header class="justify-content-start h-auto p-0 m-0">
                  <mat-panel-title class="med_sub-connector-title justify-content-center">
                    <p class="s-body">
                      <!-- <span class="secondary-color">Multiple types</span> -->
                      {{ "sub_connectors" | translate
                      }}<span class="s-body">({{ connector.subconnectors.length }})</span>
                    </p>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @for (subConnector of connector.subconnectors; track $index) {
                  @if (subConnector.status === "active") {
                    <div>
                      <div
                        class="med_sub-connector-list-item d-flex justify-content-between align-items-center py-1 px-0"
                      >
                        <div class="med_sub-connector-start-col d-flex justify-content-start align-items-center w-100">
                          @if (subConnector.connector.icon) {
                            <img
                              class="med_sub-connector-img object-fit-contain flex-shrink-0 my-0 mx-1"
                              [src]="subConnector.connector.icon"
                              [alt]="subConnector.name"
                            />
                          }
                          <p
                            class="xl-body medium text-truncate mw-100 text-start d-flex flex-column"
                            [attr.id]="'dis-connected-subconnector' + subConnector.uuid"
                            [ngbTooltip]="
                              isOverflowText('dis-connected-subconnector' + subConnector.uuid) ? subConnector.name : ''
                            "
                          >
                            <span class="l-body">{{ subConnector.name }}</span>
                            <span class="s-body secondary-color">{{ "news_and_media" | translate }}</span>
                          </p>
                        </div>
                        <div class="d-flex justify-content-end align-items-center">
                          <!--<div
                    *ngIf="processing && connectorUpdatedUuid === subConnector.uuid"
                    class="med_spinner-border position-absolute text-dark"
                    role="status"
                  ></div>-->
                          <div class="form-check form-switch pe-auto form_active_toggle">
                            <label [for]="subConnector.name"></label>
                          </div>
                          <!-- <p class="s-body secondary-color">{{ "news_and_media" | translate }}</p> -->
                          <!-- Three dots menu -->
                          <mat-icon-button
                            class="three-dots-vetical-subconnector d-flex justify-content-center align-items-center"
                            [matMenuTriggerFor]="menu"
                          >
                            <app-icon icon="ellipsis-vertical" />
                          </mat-icon-button>
                          <mat-menu #menu="matMenu">
                            <div class="three-dots-menu">
                              <button mat-menu-item (click)="openInfoModal(subConnector)">
                                <app-icon icon="circle-info" class="icon-active" />{{ "about" | translate | titlecase }}
                                {{ connector.name }}
                              </button>
                            </div>
                          </mat-menu>
                          <!-- #Three dots menu -->
                        </div>
                      </div>
                    </div>
                  }
                }
              </mat-expansion-panel>
            </div>
          }
          @if (processing && connectorUpdatedUuid === connector.uuid) {
            <div class="med_spinner-border position-absolute text-dark" role="status"></div>
          }
        </div>
      </div>
    }
    <!-- #Connector login -->
  </section>
}
@if (isWorkspaceConnector) {
  <section class="med_workspace-connector" #workspaceCard>
    <div class="med_connector-list position-relative w-100">
      <div class="d-flex justify-content-between align-items-center">
        <div class="med_connector-start-col d-flex justify-content-start align-items-start flex-column w-100">
          @if (connector.connector.icon || connector.connection_parameters.favicon) {
            <img
              class="med_connector-img object-fit-contain"
              [alt]="connector.name"
              [src]="connector.connector.icon ? connector.connector.icon : connector.connection_parameters.favicon"
            />
          }
          <div class="med_connector-info w-100 me-2">
            <h2 class="xs-title text-truncate text-start">{{ connector.name }}</h2>
            <!--<p class="s-body secondary-color mt-1">Multiple Types</p>-->
          </div>
        </div>
        <div class="med_connector-end-col d-flex justify-content-end align-items-end flex-shrink-0 flex-column">
          <!-- Three dots menu -->
          <mat-icon-button
            class="three-dots-vetical position-relative d-flex justify-content-center align-items-center"
            [matMenuTriggerFor]="menu"
          >
            <app-icon icon="ellipsis-vertical" />
          </mat-icon-button>
          <mat-menu #menu="matMenu">
            <div class="three-dots-workspace-menu">
              <button mat-menu-item (click)="editWorkspaceConnector(connector)">
                <app-icon icon="pen-clip" class="icon-active" /><span class="l-body">{{
                  "edit" | translate | titlecase
                }}</span>
              </button>
              <button mat-menu-item (click)="toggleWorkspaceConnectorStatus(connector)">
                @if (connector.status == "inactive") {
                  <app-icon icon="eye" class="icon-active" /><span class="l-body">{{
                    "turn_visible" | translate | titlecase
                  }}</span>
                }
                @if (connector.status == "active") {
                  <app-icon icon="eye-slash" class="icon-active" /><span class="l-body">{{
                    "turn_idle" | translate | titlecase
                  }}</span>
                }
              </button>
              <button mat-menu-item (click)="deleteWorkspaceConnector(connector)">
                <app-icon icon="trash-can" class="icon-active" />
                <span class="l-body">{{ "delete_connector" | translate | titlecase }}</span>
              </button>
              <button mat-menu-item (click)="duplicateConnector(connector)">
                <app-icon icon="clone" class="icon-active" />
                <span class="l-body">{{ "duplicate_connector" | translate | titlecase }}</span>
              </button>
              <button mat-menu-item (click)="openInfoModal(connector)">
                <app-icon icon="circle-info" class="icon-active" />
                <span class="l-body">{{ "description" | translate | titlecase | titlecase }}</span>
              </button>
            </div>
          </mat-menu>
          <!-- #Three dots menu -->
          @if (!connector.subconnectors.length) {
            <ng-container>
              @if (connector.status == "active") {
                <p class="med_connector-state d-flex justify-content-center align-items-center me-3 m-body bold active">
                  {{ "visible" | translate }}
                </p>
              }
              @if (connector.status == "inactive") {
                <p class="med_connector-state d-flex justify-content-center align-items-center me-3 m-body bold">
                  {{ "idle" | translate }}
                </p>
              }
            </ng-container>
          }
        </div>
      </div>
      @if (connector.subconnectors.length) {
        <div class="med_sub-connectors">
          @for (subConnector of connector.subconnectors; track subConnector) {
            <div class="med_sub-connector d-flex justify-content-between align-items-center">
              <div class="med_sub-connector-start-col d-flex justify-content-start align-items-center w-100">
                @if (subConnector.connector.icon) {
                  <img
                    class="med_sub-connector-img object-fit-contain flex-shrink-0 my-0 mx-1"
                    [src]="subConnector.connector.icon"
                    [alt]="subConnector.name"
                  />
                }
                <div class="med_sub-connector-info w-100 me-2">
                  <p class="l-body text-truncate mw-100 text-start">{{ subConnector.name }}</p>
                  <!--<p class="s-body secondary-color">Email client</p>-->
                </div>
              </div>
              <div class="d-flex justify-content-end align-items-center">
                @if (subConnector.status == "active" && connector.status != "inactive") {
                  <p
                    class="med_connector-state d-flex justify-content-center align-items-center me-3 m-body bold active"
                  >
                    {{ "visible" | translate }}
                  </p>
                }
                @if (subConnector.status == "inactive" || connector.status == "inactive") {
                  <p class="med_connector-state d-flex justify-content-center align-items-center me-3 m-body bold">
                    {{ "idle" | translate }}
                  </p>
                }
                <!-- Three dots menu -->
                <mat-icon-button
                  class="three-dots-vetical position-relative d-flex justify-content-center align-items-center"
                  [matMenuTriggerFor]="menu"
                >
                  <app-icon icon="ellipsis-vertical" />
                </mat-icon-button>
                <mat-menu #menu="matMenu">
                  <div class="three-dots-workspace-menu">
                    <button mat-menu-item (click)="editWorkspaceConnector(subConnector)">
                      <app-icon icon="pen-clip" class="icon-active" /><span class="l-body">{{
                        "edit" | translate | titlecase
                      }}</span>
                    </button>
                    <button mat-menu-item (click)="toggleWorkspaceConnectorStatus(subConnector)">
                      @if (subConnector.status == "inactive") {
                        <app-icon icon="eye" class="icon-active" /><span class="l-body">{{
                          "turn_visible" | translate | titlecase
                        }}</span>
                      }
                      @if (subConnector.status == "active") {
                        <app-icon icon="eye-slash" class="icon-active" /><span class="l-body">{{
                          "turn_idle" | translate | titlecase
                        }}</span>
                      }
                    </button>
                    <button mat-menu-item (click)="openInfoModal(subConnector)">
                      <app-icon icon="circle-info" class="icon-active" />
                      <span class="l-body">{{ "description" | translate | titlecase }}</span>
                    </button>
                  </div>
                </mat-menu>
                <!-- #Three dots menu -->
              </div>
            </div>
          }
        </div>
      }
    </div>
  </section>
}
